// @ts-nocheck
/**
 * Converts a UTC date to the local timezone.
 * The function takes a UTC date as input and returns a new Date object that represents
 * the same date, but adjusted to the local timezone of the user's environment, DROPPING the timezone offset from the UTC date.
 *
 * This is useful when you have a date in UTC and want to display it in the user's local time without applying
 * the timezone offset, effectively treating the UTC date as if it were in the local timezone.
 *
 * <example>
 * This is basically dropping the timezone offset from the UTC date, which effectively converts it to local time.
 * For example, if the UTC date is "2026-01-01T00:00:00Z" and the user's local timezone is UTC-4,
 * the function will return a Date object representing "2026-01-01T00:00:00-4:00" in the local timezone.
 *
 * "2026-01-01T00:00:00Z" -> "2026-01-01T00:00:00-4:00" (if local timezone is UTC-4)
 * </example>
 * @param utcDate - The UTC date to be converted to local time.
 * @returns A new Date object representing the local time equivalent of the input UTC date.
 */
export const convertUTCDateToLocalDate = (utcDate: Date) => {
    const date = new Date(utcDate);
    const timeDiff = date.getTimezoneOffset() * 60000;
    return new Date(date.valueOf() + timeDiff);
};
